import React from "react";

import { Popover, SvgIcon } from "@material-ui/core";

import { useStyles } from "./TableHeaderFilterStyles";

import { ReactComponent as TableHeaderFilterIcon } from "../../assets/svg/TableHeaderFilterIcon.svg";
import { generateElementIdentifier } from "utils/ApplicationUtils";
import { DATA_IDENTIFIER, ELEMENT } from "../App/app-constant";

interface TableHeaderFilterInterface {
  openPopUp: any;
  anchorEl: any;
  //
  handleFilterPopupOpen: any;
  handleFilterPopupClose: any;
  //
  popUpContent: any;
  anchorName: any;
  //
  filterType?: any;
}

const TableHeaderFilter = (props: TableHeaderFilterInterface) => {
  const classes = useStyles();
  const {
    openPopUp,
    anchorEl,
    //
    handleFilterPopupOpen,
    handleFilterPopupClose,
    //
    popUpContent,
    anchorName,
    filterType,
  } = props;

  return (
    <>
      {filterType !== undefined && filterType === "dateRange" ? (
        popUpContent
      ) : (
        <>
          <SvgIcon data-testid={generateElementIdentifier({ key: DATA_IDENTIFIER.POP_OVER_TRIGGER, customKey: anchorName, element: ELEMENT.SVG_ICON })} key={anchorName} className={classes.rootIcon} component={TableHeaderFilterIcon} onClick={handleFilterPopupOpen} />
          <Popover
            open={openPopUp}
            id="filter-popover-area"
            data-testid={generateElementIdentifier({key: DATA_IDENTIFIER.POP_OVER, customKey: anchorName, element: ELEMENT.POP_OVER})}
            classes={{
              paper: classes.paperProps,
            }}
            anchorEl={anchorEl}
            transformOrigin={{ vertical: -20, horizontal: "left" }}
            onClose={handleFilterPopupClose}
          >
            {popUpContent}
          </Popover>
        </>
      )}
    </>
  );
};

export default React.memo(TableHeaderFilter);
